import store from '@/stores';
import i18n from '@/locales/init'; 
import { Analyze, analyzeGenerator } from './analyzeGenerator';

export const reg = /\$([0-9]+(?:\.[0-9]+)?)\$/g;
/** 题目类型 */
export enum IRCQuestionTypeEnum {
  /** 判断题 */
  TOF = 1,
  /** 从属配对 */
  DM = 2,
  /** 句子信息配对 */
  SIM = 3,
  /** 总结无选项 */
  SNC = 4,
  /** 单选 */
  MC = 5,
  /** 小标题 */
  ST = 6,
  /** 多选题 */
  MS = 7,
  /** 句子填空 */
  SFI = 8,
  /** 句子配对 */
  SM = 9,
  /** 总结有选项题 */
  SWO = 10,
  /** 简答题 */
  SA = 11,
  /** 图片题 */
  PT = 12,
  /** 表格题 */
  TA = 13,
  /** 自定义多选 */
  CMS = 14
}
export interface IRCQuestionItemOption {
  title: string;
  content: string;
}

export type IRCInfoContentTitleKey =
  'pre-A'
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H'
  | 'I'
  | 'J'
  | 'K'
  | 'L'
  | 'M'
  | 'N'
  | 'O'
  | 'P'
  | 'Q'
  | 'R'
  | 'S'
  | 'T'
  | 'U'
  | 'V'
  | 'W'
  | 'X'
  | 'Y'
  | 'Z';


export interface IRCQuestionItem {
  id: number;
  title: string;
  number: number;
  option: IRCQuestionItemOption[];
  sub_essay_code: IRCInfoContentTitleKey;
  analyze: any[];
  display_answer: string;
  key_locating_words: any[];
  central_sentences: Array<{
    target_para: number;
    index: number;
    length: number;
    sentence: string; // 英文
    translation: string;
  }>;
  ai_analyze: string;
}


export interface IRCQuestion {
  group_id: number;
  type: IRCQuestionTypeEnum;
  desc: string;
  collect: any;
  collect_option: any;
  list: IRCQuestionItem[];
  img_url?: string;
  table?: {
    title: string;
    content: any[];
  };
}


export type QuestionInfo = IRCQuestionItem & {
  groupInfo: IRCQuestion;
  analyze: Analyze[];
  sectionLabel?: string;
  contextText?: string;
};


const generateAnalyzeList = (q: IRCQuestionItem): Analyze[] => {
  return analyzeGenerator({
    display_answer: q.display_answer,
    ai_analyze: q.ai_analyze,

    key_locating_words: q.key_locating_words,

    central_sentences: q.central_sentences,
  });
};

export function getReference(group: any, item: any) {
  const {type} = group;
  const {number, id} = item;
  const inputStr = ' __ ';
  const reference = {content: '', payload: {number, question_id: id}};
  if ([1,2,3,5,9, 11].indexOf(type) > -1) {
    reference.content = item.title;
  } else if ([6].indexOf(type) > -1 ) {
    reference.content = i18n.t('common.dauyan_paragraph_order', {v: item.sub_essay_code});
  } else if ([12].indexOf(type) > -1) {
    reference.content = i18n.t('common.dauyan_order_value_question_spaces', {v: number});
  } else if ([4,8, 10].indexOf(type) > -1) {
    const {collect} = group;
    let result = '';
    const arr = collect.split('.').find((str: string) => {
      const replaceStr = str.replace(new RegExp('\\$' + id + '\\$'), inputStr);
      if (replaceStr !== str) {
        result = replaceStr;
        return true;
      }
    });
    // const result = collect.replace(/\$\d+\$/g, inputStr).replace(/\n/g, '');
    reference.content = result;
  } else if ([7].indexOf(type) > -1) {
    reference.content = group.collect_option.title;
  } else if ([13].indexOf(type) > -1) {
    const {table: {content}} = group;
    let result = '';
    content.find((cols: any) => {
      return cols.find((str: any) => {
        if (typeof str === 'string') {
          const replaceStr = str.replace(new RegExp('\\$' + id + '\\$'), inputStr);
          if (replaceStr !== str) {
            result = replaceStr.replace(/\n/g, '');
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
    });
    reference.content = result;
  }
  return reference;
}

export const getReadingQuestionInfo = (n: number): any => {
  const originData = store.getState().reading.pageDataAll;
  if (!originData) {
    return null;
  }
  for (let m = 0; m < originData.length; m++ ) {
    const originDataItem = originData[m].question;
    for (const group of originDataItem.question) {
      for (let i = 0; i < group.list.length; ++i) {
        const q = group.list[i];
        if (q.number === n) {
          const data = {
            groupInfo: group,
            reference: getReference(group, q),
            answer: generateAnalyzeList(q).map((ele: any, index: number) => {
              return {
                key: `${n}_${index}`,
                ...ele,
                payload: ele.location,
              };
            }),
          };
          return data;
        }
      }
    }
  }
  return null;
};

